export const SEARCH_SPLIT_REGEX = /[\s+/]/g;

export const DROPDOWN_SEARCH_DEFAULT_MAX_LENGTH = 200;
